import { render, staticRenderFns } from "./ProductTableModal.vue?vue&type=template&id=049a7eac&"
import script from "./ProductTableModal.vue?vue&type=script&lang=js&"
export * from "./ProductTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports